import { Button, Subheader3 } from '@collaborate-health/uikit'

import { buttonClasses, styled } from '@mui/material'

export const AnswerStatusText = styled(Subheader3)(({ theme }) => ({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  textAlign: 'left',
}))

export const AnswerStatusButton = styled(Button)(({ theme }) => ({
  [`&.${buttonClasses.root}`]: {
    padding: theme.spacing(0.5, 1),
    minWidth: 'unset',
    maxWidth: 180,
    margin: theme.spacing(-0.5),
    overflow: 'hidden',
  },
}))

